import { motion } from "framer-motion";
import React from "react";
import DropdownMenu from "../../components/dropdown-menu";
import { DropdownItemProps } from "../../components/dropdown-menu/DropdownItem";

interface DropdownMenuPopUpProps {
  containerStyle: string;
  optionsList: DropdownItemProps[];
  setShowPopUp: React.Dispatch<React.SetStateAction<boolean>>;
}

/**
 * Definition of the variants of this component
 */
const variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: {
    opacity: 0,
    transition: { duration: 0.1, ease: "easeOut" },
  },
};

const DropdownMenuPopUp: React.FC<DropdownMenuPopUpProps> = ({
  containerStyle,
  optionsList,
  setShowPopUp,
}) => {
  return (
    <>
      <motion.div
        className="fixed top-0 left-0 w-screen h-screen bg-neutral-300 bg-opacity-20 backdrop-blur-[2px] inline-flex items-end justify-center z-20"
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.1, ease: "easeOut" }}
        onClick={() => setShowPopUp(false)}
      />
      <DropdownMenu containerStyle={containerStyle} optionsList={optionsList} />
    </>
  );
};

export default DropdownMenuPopUp;
